module.exports = __webpack_public_path__ + "static/media/excel-doc.d10a7cca.svg";